window.addEventListener('DOMContentLoaded', () => {
  const destination = document.querySelector('.custom-description');

  function updateColor(element) {
    if (element && element.getAttribute('data-has-preorder') === 'true') {
      element.classList.add('cm-preorder');
    } else if (element) {
      element.classList.remove('cm-preorder');
    }
  }

  // Opdater farve ved load
  updateColor(destination);

  // Og ved variant skift
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const { html, variant, sectionId } = event.data;
    const source = html.querySelector(`[data-section='${sectionId}'] .custom-description`);
    const destination = document.querySelector(`[data-section='${sectionId}'] .custom-description`);

    if (source && destination) {
      destination.innerHTML = source.innerHTML;
      destination.setAttribute('data-has-preorder', source.getAttribute('data-has-preorder'));

      updateColor(destination);
    }
  });
});